import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, of } from "rxjs";
import { throwError } from "rxjs";
import { map, catchError, flatMap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { parseJwt } from "src/_helpers/utils";
import { User } from "src/_models/user";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { roleTypeGroup } from "src/_constants/roleType";
@Injectable({ providedIn: "root" })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  private pending2faLogin: { userId: string; password: string; IP: string } | null =
    null;

  horizontalPosition: MatSnackBarHorizontalPosition = "end";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  constructor(
    private http: HttpClient,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(sessionStorage.getItem("currentUser"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  setPending2faLogin(pending: { userId: string; password: string; IP: string }) {
    this.pending2faLogin = pending;
  }

  getPending2faLogin() {
    return this.pending2faLogin;
  }

  clearPending2faLogin() {
    this.pending2faLogin = null;
  }
  public httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("jwtToken"),
    }),
  };

  private completeLogin(user: any): Observable<any> {
    const token = parseJwt(user.token);
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("jwtToken", user.token);
    sessionStorage.setItem("currentUser", JSON.stringify({ ...user, ...token }));

    //to fetch categories(Exchange,SportsBook) for OperatorId
    const userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
    return this.getCategory(userRole.operatorId, userRole.userId).pipe(
      map(() => {
        this.currentUserSubject.next({ ...token, ...user });
        return { ...user, ...token };
      })
    );
  }

  login(
    username: string,
    password: string,
    ipAddress: string,
  ): Observable<any> {
    return this.http
      .post<any>(`${environment.apiUrl}/login`, {
        userId: username,
        password,
        IP: ipAddress,
      })
      .pipe(
        flatMap((user) => {
          if (user && user["2faRequired"] === true) {
            return of(user);
          }

          return this.completeLogin(user);
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  login2fa(
    username: string,
    password: string,
    ipAddress: string,
    otp: string
  ): Observable<any> {
    return this.http
      .post<any>(`${environment.apiUrl}/login/2fa`, {
        userId: username,
        password,
        IP: ipAddress,
        otp,
      })
      .pipe(
        flatMap((user) => this.completeLogin(user)),
        catchError((error) => throwError(() => error))
      );
  }

  navigateAfterLogin(data: any) {
    const role = data && data.role;
    if (role === "SAPAdmin") {
      this.router.navigate(["/dashboard"]);
    } else if (role === "SAPUser") {
      this.router.navigate(["/administration/games"]);
    } else if (role === "RiskAdmin") {
      this.router.navigate(["/administration/providers"]);
    } else if (roleTypeGroup.includes(role)) {
      this.router.navigate(["/reports/bet_list/bets"]);
    } else if (role == "VirtualUser") {
      this.router.navigate(["/virtual-metrics"]);
    } else if (role == "MetricsAdmin") {
      this.router.navigate(["/sap-metrics"]);
    } else if (role == "InvoiceAdmin") {
      this.router.navigate(["/invoice/report"]);
    } else if (role == "RolexAdmin") {
      this.router.navigate(["/administration/providers"]);
    } else {
      this.router.navigate(["/administration/users"]);
    }
  }

  getCategory(oid: string, uid:string){
    return this.http.post<any>(
      `${environment.mappingUrl}/core/enabled-categories`,
      {
        operatorId: oid,
        userId: uid,
      },
      this.httpOptions
    ).pipe(
      map((response) => {
        sessionStorage.setItem("category", JSON.stringify(response.categories));
      }),
      catchError((error) => {
        return error;
      })
    );
  }

  openSnackBar(msg: string) {
    this._snackBar.open(msg, "close", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["green-snackbar"],
    });
  }

  openErrorSnackBar(msg: string) {
    this._snackBar.open(msg, "close", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["red-snackbar"],
    });
  }

  logout() {
    // remove user from local storage to log user out
    this.clearPending2faLogin();
    try {
      this.http
        .post<any>(`${environment.apiUrl}/logout`, 
        {token: JSON.parse(sessionStorage.getItem("currentUser")).token})
        .subscribe((res) => {
          sessionStorage.removeItem("currentUser");
          this.currentUserSubject.next(null);
          this.router.navigateByUrl("/login");
          // window.location.reload();
        });
    } catch (err) {
      console.log("@@@", err);
      sessionStorage.removeItem("currentUser");
      this.router.navigateByUrl("/login");
    }
  }
}
